import React from "react";
import TabFiles from "../../Files/TabFiles";

interface FilesTabProps {
  managementUnitId: number;
  entityId: number;
}

const FilesTab: React.FC<FilesTabProps> = ({ managementUnitId, entityId }) => {
  if (!entityId) return null;

  return (
    <TabFiles
      managementUnitId={managementUnitId}
      context="managementUnit"
      entityId={entityId}
    />
  );
};

export default FilesTab;
